import { render, staticRenderFns } from "./EditUtilisateurInfos.vue?vue&type=template&id=2a4b2c06&"
import script from "./EditUtilisateurInfos.vue?vue&type=script&lang=ts&"
export * from "./EditUtilisateurInfos.vue?vue&type=script&lang=ts&"
import style0 from "./EditUtilisateurInfos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports